var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "fill-height",
      class: _vm.$vuetify.theme.dark ? "primary" : "white",
      staticStyle: { "border-radius": "15px" }
    },
    [
      _c("v-card-text", [
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "div",
            { staticClass: "mr-3" },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    color: _vm.$vuetify.theme.dark ? "white" : "primary",
                    size: "60"
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.info.icon) +
                      "\n                    "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "d-flex align-end" }, [
              _c(
                "h3",
                {
                  staticClass: "display-1 mr-2 font-weight-bold",
                  class: _vm.$vuetify.theme.dark
                    ? "white--text"
                    : "primary--text"
                },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.info.value) +
                      "\n                        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-0 accent--text font-weight-bold" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.info.description) +
                  "\n                    "
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }